//@flow
import React, { PureComponent } from "react";
import TextField from "material-ui/TextField";
import FlatButton from "material-ui/Button";
//import Dropzone from 'react-dropzone'
import FileFileUpload from "material-ui-icons/FileUpload";
import NavigationArrowForward from "material-ui-icons/ArrowForward";
import LinkIcon from "material-ui-icons/Link";

export default class DropField extends PureComponent {
  state = {
    drag: false,
    downloading: false
  };

  txt = null;

  componentDidMount() {
    document.body.addEventListener("dragover", e => {
      e.stopPropagation();
      e.preventDefault();
      if (e instanceof DragEvent && e.dataTransfer) {
        e.dataTransfer.dropEffect = "copy";
      }
      this.setState({ drag: true });
    });
    document.body.addEventListener("dragleave", e => {
      this.setState({ drag: false });
    });
    document.body.addEventListener("dragend", e => {
      this.setState({ drag: false });
    });
    document.body.addEventListener("drop", e => {
      e.stopPropagation();
      e.preventDefault();
      this.setState({ drag: false });
      if (e instanceof DragEvent && e.dataTransfer) {
        var files = e.dataTransfer.files; // Array of all files
        this.fileReader("Dropped file " + files[0].name, files[0]);
        if (window.ga) window.ga("send", "event", "drop", files[0].name);
      }
    });

    if (this.txt) this.txt.focus();

    if (this.txt)
      this.txt.addEventListener("paste", e => {
        var val = e.clipboardData.getData("text");
        setTimeout(() => {
          val.match(/^http/) && this.downloadImage();
        }, 1);
        if (window.ga)
          window.ga(
            "send",
            "event",
            "paste",
            "url",
            "" + e.clipboardData.getData("text")
          );
      });
  }

  fileReader(uri: string, file: File) {
    console.log(file);
    if (file.type.match(/image.*/)) {
      var reader = new FileReader();
      reader.onload = e2 => {
        // finished reading file data.
        this.props.onChangedImage(uri, e2.target.result.split("base64,")[1]);
      };
      reader.readAsDataURL(file); // start reading the file data.
    }
    else {
      alert("This doesn't appear to be a valid image. If you pasted a link, try to download the image file and upload.");
    }
  }

  downloadImage = async () => {
    var uri = this.txt.value;
    var res = await fetch('//translate-image.com/v2/cors.php?csurl=' + encodeURIComponent(uri));
    var blob = await res.blob();
    this.fileReader(uri, blob);
  };

  uploadImage = async (e: any) => {
    e.target.files.length &&
      this.fileReader(
        "Uploaded file " + e.target.files[0].name,
        e.target.files[0]
      );
  };

  render() {
    return (
      <div className="lang-selection" style={{ marginBottom: 20 }}>
        {!this.state.drag ? (
          <span>
              <TextField
            className="url-field"    
              inputRef={el => (this.txt = el)}
              placeholder={this.props.imgSrc}
              label={
                !this.props.imgSrc &&
                <span>
                  <LinkIcon style={{ verticalAlign: "middle" }} /> Image URL
                </span>
              }
            >
              link
            </TextField>
            <FlatButton
              component="label"
              style={{ verticalAlign: "middle" }}
            >
              <FileFileUpload /> Upload
              <input
                type="file"
                onChange={this.uploadImage}
                style={{ display: "none" }}
              />
            </FlatButton>
            <FlatButton
              disabled={this.state.downloading}
              onClick={this.downloadImage}
              component="label"
              style={{ verticalAlign: "middle" }}
            >
              <NavigationArrowForward /> Go
            </FlatButton>
          </span>
        ) : (
          <div className='droptarget'>Drop your file here to upload</div>
            )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/DropField.js